import { GetMarketplaceGallery, GetMarketplaceGalleryVariables } from './__generated__/GetMarketplaceGallery'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'

import { gql } from 'apollo-boost'

const QUERY = gql`
  query GetMarketplaceGallery($input: GetMarketplaceGalleryInputV2!) {
    marketplaceGalleryV2(input: $input) {
      ... on MarketplaceGalleryErrorV2 {
        type
        error
      }
      ... on MarketplaceGalleryV2 {
        id
        isNote
        items {
          id
          image
          description
          marketplaceListing {
            id
            title
          }
        }
      }
    }
  }
`

interface IUseGetMarketplaceGalleryProps {
  isNote?: boolean
}

export const useGetMarketplaceGallery = ({ isNote = false }: IUseGetMarketplaceGalleryProps) => {
  return useQuery<GetMarketplaceGallery, GetMarketplaceGalleryVariables>(QUERY, {
    variables: {
      input: { isNote }
    }
  })
}

export const useGetMarketplaceGalleryLazy = ({ isNote = false }: IUseGetMarketplaceGalleryProps) => {
  return useLazyQuery<GetMarketplaceGallery, GetMarketplaceGalleryVariables>(QUERY, {
    variables: {
      input: { isNote }
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })
}
